import React, { FC, useCallback } from 'react';
import { DragDropContext, Droppable, DropResult } from 'react-beautiful-dnd';
import { moveCategory } from 'data/cacheHelpers/menu';
import useMenu from 'data/hooks/useMenu';
import Category from './Category';
import { Props } from './types';

const Categories: FC<Props> = ({ brandId, isProcessing }) => {
  const { data, allowAddItem } = useMenu(brandId);

  const handleDragEnd = useCallback(
    ({ source, destination }: DropResult) => {
      if (!destination || destination.droppableId !== 'categories') {
        return;
      }
      moveCategory({
        from: source.index,
        to: destination.index,
        brandId,
      });
    },
    [brandId],
  );

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="categories">
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            <div>
              {data?.structure.map((category, index) => (
                <Category
                  key={category.id}
                  index={index}
                  brandId={brandId}
                  id={category.id}
                  name={category.name}
                  items={category.childrenEntities}
                  itemsMap={data.items}
                  isProcessing={isProcessing}
                  allowAddItem={allowAddItem}
                />
              ))}
            </div>
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default Categories;
